import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppShell } from "@/components/AppShell";
import { RequireAuth } from "@/components/RequireAuth";
import { LoginPage } from "@/features/auth/LoginPage";
import { AccessDeniedPage } from "@/features/auth/AccessDeniedPage";
import { ChooseFlowPage } from "@/features/home/ChooseFlowPage";
import { UploadPage } from "@/features/upload/UploadPage";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { PaaPage } from "@/features/paa/PaaPage";
import { HistoryPage } from "@/features/history/HistoryPage";
import { SavedPropertiesPage } from "@/features/properties/SavedPropertiesPage";
import { Toaster } from "@/lib/toast";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/access-denied" element={<AccessDeniedPage />} />

          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route index element={<ChooseFlowPage />} />
            <Route path="objections" element={<UploadPage />} />
            <Route path="paa" element={<PaaPage />} />
            <Route path="history" element={<HistoryPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="saved-properties" element={<SavedPropertiesPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
